import { getStoredItem } from "../shared/Utils";

const retainCriticalData = () => {
    let customerColumnConfigData = null;
    let vendorColumnConfigData = null;

    if (getStoredItem("customerColumnConfig")) {
        customerColumnConfigData = getStoredItem("customerColumnConfig");
    }

    if (getStoredItem("vendorColumnConfig")) {
        vendorColumnConfigData = getStoredItem("vendorColumnConfig");
    }
    localStorage.clear();

    if (customerColumnConfigData)
        localStorage.setItem("customerColumnConfig", JSON.stringify(customerColumnConfigData));
    if (vendorColumnConfigData)
        localStorage.setItem("vendorColumnConfig", JSON.stringify(vendorColumnConfigData));
};

export default retainCriticalData;
